//中文繁体
export default {
  Login: {
    Title: "登入您的帳戶",
    describe: "請登入或創建一個帳戶以開始使用。",
    Google: "使用 Google 登入",
    Apple: "使用 Apple 登入",
    or: "或",
    Emailplaceholder: "電子郵件地址",
    Passwordplaceholder: "密碼",
    Login: "登入",
    forgot: "忘記密碼？",
    notAccount: "還沒有 Fineshare 帳戶？",
    Signup: "註冊",
    InvalidEmail: "無效的電子郵件格式。",
    InvalidPassword: "密碼必須至少 6 個字符。",
    loading: "加載中..",
    login: "登入",
    errorText: "登入失敗，請檢查您的帳號和密碼",
  },
  signup: {
    Title: "創建您的帳戶",
    describe: "幾秒鐘內創建您的 Fineshare 帳戶。",
    Google: "使用 Google 註冊",
    Apple: "使用 Apple 註冊",
    or: "或",
    Emailplaceholder: "輸入電子郵件地址",
    Passwordplaceholder: "輸入6位數密碼",
    Already: "已經有帳戶了？",
    Login: "登入",
    By: "創建帳戶即表示我同意我已閱讀並接受",
    Privacy: "隱私政策",
    Terms: "使用條款。",
    and: "和",
    signupText: "創建您的帳戶",
    InvalidEmail: "無效的電子郵件格式。",
    InvalidPassword: "密碼必須至少 6 個字符。",
    loading: "加載中..",
    passwordError: "該電子郵件地址已被註冊",
    again: "您請求過於頻繁，請稍後再試",
    Registration: "註冊失敗，請檢查您的電子郵件和密碼。",
    hasRegistered: "該電子郵件地址已被註冊",
  },
  Home: {
    Welcome: "歡迎來到 Fineshare 帳戶中心",
  },
};
